import React from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import BossDialog from '../../components/BossDialog';
import { useTranslation } from '../../locale/useTranslation';
import { DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';

const PromotionPostHistoryPopup = ({ item = {}, onClose }) => {
    console.log({item})
    const lang = useTranslation();

    const HistoryActionCell = (props) => {
        const isPublished = props.dataItem?.isPublished === true;
        return (
            <td>
                <span className={`badge ${isPublished ? 'bg-success' : 'bg-danger'} text-white px-2 py-1`}>
                    {isPublished ? lang.published_label : lang.unpublished_label}
                </span>
            </td>
        );
    };

    const postTitle = item?.Post?.Title ?? "";
    const dialogTitle = postTitle ? `${lang.publish_history_label} - ${postTitle}` : lang.publish_history_label;

    return (
        <BossDialog title={dialogTitle} onClose={onClose} width="670px" height="auto">
            <div className="p-3">
                <Grid data={item?.history || []} style={{ maxHeight: "450px" }}>
                    <GridColumn field="isPublished" title="Action" cell={HistoryActionCell} width="130px" />
                    <GridColumn field="postId" title="Post ID" />
                    <GridColumn field="timestamp" title="Timestamp" cell={DateTimeCell} width="200px" />
                </Grid>
            </div>
        </BossDialog>
    );
};

export default PromotionPostHistoryPopup;
